/**
 * The app's one rule for "does this path belong to that menu route": the route itself or anything
 * nested under it ("/company/settings/port" matches "/company/settings/port/123", but not
 * "/company/settings/portal"). Used for the sidebar's active item, route authorisation and
 * permission lookup, so all three always agree.
 *
 * Callers normalise their inputs (e.g. trailing slashes) exactly as they did before.
 */
export function isRouteMatch(path, route) {
  return path === route || path.startsWith(route + "/")
}
